import React, { useState } from "react";
import { useRef } from "react";
import "../styles/searchInput.scss";

export default function SearchInput({
  placeholder = "Search",
  onSubmit,
  spinning,
}) {
  const [search, setsearch] = useState();

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit && onSubmit(search);
    // formRef.current.reset();
  };
  const handleChange = (event) => {
    const { value } = event.target;
    setsearch(value);
  };
  const formRef = useRef();
  return (
    <form ref={formRef} onSubmit={handleSubmit} className="search-container">
      <input
        disabled={spinning}
        name="search"
        onChange={handleChange}
        placeholder={placeholder}
      />
      <button onClick={handleSubmit} type="submit" disabled={spinning}>
        {spinning && (
          <i className="fa fa-spinner fa-spin" style={{ marginRight: 5 }}></i>
        )}
        Search
      </button>
    </form>
  );
}
